import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD81IjsO-2eyIm2r2hNJ_Z4XCcgmY6JPsQ",
  authDomain: "food-blog-95839.firebaseapp.com",
  projectId: "food-blog-95839",
  storageBucket: "food-blog-95839.firebasestorage.app",
  messagingSenderId: "829846589447",
  appId: "1:829846589447:web:81d68639687ed6584f9aa2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;